<template>
  <div class="game-tr-select-game-with-text" :style="setGameStyle()">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div class="text-container" :style="getTextStyle()">
      <component :is="dynComponent" v-bind="$props"></component>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
// import Vue from 'vue';
import * as utils from '../../Utils/inputUtilsV2';
import TrSelect from '../TrSelect/TrSelectV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'tr-select-game-with-text-v2',
  components: { TrSelect },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      imageData: {},
      text: this.startGameConfig.item.text,
      selected: [],
      baseItems: _.cloneDeep(this.startGameConfig.items),
    };
  },
  created() {},
  beforeMount() {
    this.init();
    this.text = this.parseText(this.text);
  },
  methods: {
    /**
     * parsing function. Replace markes (__elem0__,__elem1__, etc.) to component and passing all data
     * @method parseText
     * @param  {String}  text base text with markers
     * @return {String}       reparsed text with correct components
     */
    parseText(text) {
      // let regExp = /__\w*__/g;
      text = _.split(text, /__\w*__/g);
      // text = regExp.exec(text);
      let parseText = [];
      parseText.push('<span>');
      _.each(text, (item, index) => {
        if (index <= text.length - 2) {
          let newText = `<tr-select
            :config="baseItems[${index}]"
            :inputWidth="inputWidth(baseItems[${index}])"
            :inputHeight="inputHeight(baseItems[${index}])"
            :options="baseItems[${index}].options"
            :tr-select-value="selected[${index}]"
            @change="setNewValue($event,${index})"
            @click.native="resetCheckStatus"
            class=" select-style"
          ></tr-select>`;
          parseText.push('<span>');
          parseText.push(item);
          parseText.push('</span>');
          parseText.push(newText);
        } else {
          parseText.push('<span>');
          parseText.push(item);
          parseText.push('</span>');
        }
      });
      parseText.push('</span>');
      return parseText.join('');
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {
          position: 'relative',
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center,center',
        },
        this.getCustomStyle(imageData),
        {
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },
    getTextStyle() {
      let pos = this.startGameConfig.item.pos || {};
      return _.merge({ position: 'relative' }, this.getCustomStyle(this.startGameConfig.item), {
        top: utils.elementTopPosition(pos.y, this.startGameConfig.item.offsetVertical),
        left: utils.elementLeftPosition(pos.x, this.startGameConfig.item.offsetHorizontal),
        width: utils.elementWidth(this.startGameConfig.item.width),
        height: utils.elementHeight(this.startGameConfig.item.height),
      });
    },
    setGameStyle() {
      return _.merge({ position: 'absolute' }, this.getCustomStyle(this.startGameConfig), {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
        padding: this.startGameConfig.padding + '%',
        'margin-top': this.startGameConfig.marginTop + '%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    init() {
      this.prepareData();
      if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      }
      this.selected = _.map(this.startGameConfig.items, (item) => {
        return { correct: item.correct, val: '', block: false, inputStatus: null };
      });
    },
    prepareData() {
      let data = _.cloneDeep(this.startGameConfig.items);
      return data;
    },

    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    // getTextStyle(textElement) {
    //   return {
    //     'position': 'absolute',
    //     'top': utils.elementTopPosition(textElement.pos.y, textElement.offsetVertical),
    //     'left': utils.elementLeftPosition(textElement.pos.x, textElement.offsetHorizontal),
    //     'width': utils.elementWidth(textElement.width),
    //     'height': utils.elementHeight(textElement.height),
    //   };
    // },
    // getQuestionStyle(question) {
    //   return {
    //     'position': 'absolute',
    //     'top': utils.elementTopPosition(question.pos.y, question.offsetVertical),
    //     'left': utils.elementLeftPosition(question.pos.x, question.offsetHorizontal),
    //     'width': utils.elementWidth(question.width),
    //     'height': utils.elementHeight(question.height),
    //   };
    // },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // _.each(this.inputData, (item, key, collection) => {
      //   item.val = "";
      //   item.text = "";
      //   item.block = false;
      //   item.inputStatus = null;
      // });
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value.correct) {
            temVal = result && true;
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
  },
  computed: {
    dynComponent() {
      const template = this.content ? this.content : this.text;
      let data = {
        imageData: {},
        text: _.cloneDeep(this.startGameConfig.item.text),
        selected: this.selected,
        baseItems: _.cloneDeep(this.baseItems),
        // items: _.cloneDeep(this.startGameConfig.items)
      };
      return {
        template,
        mixins: [defaultMixin],
        components: { TrSelect },
        data() {
          return data;
        },
        methods: {
          selectConfig(item) {
            return _.omit(item, ['pos', 'width', 'height']);
          },
          inputWidth(item) {
            if (item.width) {
              return item.width;
            } else if (this.startGameConfig.inputWidth) {
              return this.startGameConfig.inputWidth;
            }
            return false;
          },
          inputHeight(item) {
            if (item.height) {
              return item.height;
            } else if (this.startGameConfig.inputHeight) {
              return this.startGameConfig.inputHeight;
            }
            return false;
          },
          setNewValue(value, index) {
            let trValue = _.defaults({}, value, { correct: undefined, val: '', block: false, inputStatus: null });
            trValue.val = value.text;
            _.assign(this.selected[index], trValue, { val: value });
          },
        },
        props: this.$props, // re-use current props definitions
        // props: this.$options.props // re-use current props definitions
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-select-game-with-text {
  height: 100%;
  width: 93%;
  margin-left: 1%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .text-container {
    text-align: justify;
  }
}

.marker-style {
  width: 100px;
  height: 40px;
  display: inline-block;
}
</style>
